/* eslint-disable import/prefer-default-export */
import moment from 'moment'

type DatePatterns =
  | 'MM/DD/YYYY'
  | 'MM/DD/YYYY, h:mm:ss a'
  | 'h:mm a'
  | 'MM-DD-YYYY'

export function getFormattedDate(
  date,
  format: DatePatterns = 'MM-DD-YYYY',
  utc = false
) {
  return date ? moment(date + (utc ? 'T00:00:00' : '')).format(format) : null
}
